module.exports = __webpack_public_path__ + "img/history13.5fb38c56.png";